import Vue from 'vue';
const CodeMirrorLiteJs = require('vue2-codemirror-lite-js');
import '../assets/css/blackboard.css';

// Codemirror (Code Editor) Instance with options
Vue.use(CodeMirrorLiteJs);
